import { separateDietIdAndTierIdsByUnderscore } from './mergeDietIdAndTierId.util';
import { getServerApiMenu } from '../api/client/companyDetailsApi';

export const fetchMenus = async (companyId, dietIdWithTierId, dates) => {
  if (!companyId || !dietIdWithTierId || !dates?.length) {
    return null;
  }

  const query = encodeURIComponent(
    JSON.stringify({
      ...separateDietIdAndTierIdsByUnderscore(dietIdWithTierId),
      dates,
    })
  );

  try {
    return await getServerApiMenu(query, companyId);
  } catch (error) {
    console.error('Error fetching menus:', error);
    throw error;
  }
};
